import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router preserves the scroll position on every <Link> navigation.
 * That's fine inside a single document, but jumping from "/" (the landing
 * scrolled deep to "Planuri") to "/contact" lands the user at the SAME pixel
 * offset on the new page — which on a shorter page is mostly the footer.
 *
 * Mount once inside <BrowserRouter>: every pathname change scrolls the window
 * back to the top, EXCEPT when there's a hash (e.g. /#features) — in that case
 * the browser's native anchor scroll should handle it and we must not fight
 * it.
 */
export function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname, hash]);
    return null;
}
